import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { BadgeProps } from "./Badge.types";
import { resolvePaletteRoleForegroundToken } from "../../../../functions/resolvePaletteRoleForegroundToken";
import BadgeBase from "../BadgeBase";

const Badge: React.FC<BadgeProps> = ({
	backgroundColor,
	size = "lg",
	children,
	className,
	...props
}) => {
	const block = new BemIt("Badge");
	const FG_COLOR = resolvePaletteRoleForegroundToken(backgroundColor);

	return (
		<BadgeBase
			className={addClass(className).after(block.mod(size))}
			backgroundColor={backgroundColor}
			color={FG_COLOR}
			iconColor={FG_COLOR}
			size={size}
			{...props}
		>
			{children}
		</BadgeBase>
	);
};

export default Badge;
